import { ChatItemText } from './ChatItemText';
import { ChatItemEmotionPicker } from './EmotionPicker';
import { ChatEmotionScalePicker } from './EmotionScalePicker';
import { Options } from './Options';
import { UserTextItem } from './UserTextItem';

export const ChatItemComponents = {
  UserTextItem: UserTextItem,
  TextItem: ChatItemText,
  Options: Options,
  EmotionPicker: ChatItemEmotionPicker,
  EmotionScalePicker: ChatEmotionScalePicker,
};
